import ajax from '../../lib/userAjax';
import util from '../../lib/util'
import {Store,Module,ActionContext} from 'vuex' 
interface SessionState{
    application:any,
    user:any,
    tenant:any,
    company:any,
    listOrg:any,
    roleNames:any,
    roleIds:any
}
class SessionStore implements Module<SessionState,any>{
    namespaced=true;
    state={
        application:null,
        user:null,
        tenant:null,
        company:null,
        listOrg:null,
        roleNames:null,
        roleIds:null
    }
    getters={
        hasRoles: (state:any) => (role:any) => {
            return state.roleNames.indexOf(role) !== -1
        }
    }
    actions={
        async init(content:ActionContext<SessionState,any>){
            let rep=await ajax.get('/api/services/app/Session/GetCurrentLoginInformations',{
                headers:{
                    'Abp.TenantId': util.abp.multiTenancy.getTenantIdCookie()
                }}
            );
            content.state.application = rep.data.result.application;
            content.state.user        = rep.data.result.user;
            content.state.tenant      = rep.data.result.tenant;
            content.state.company     = rep.data.result.company;
            content.state.listOrg     = rep.data.result.listOrg;
            content.state.roleNames   = rep.data.result.roleNames;
            content.state.roleIds   = rep.data.result.roleIds;
            content.state.listOrg     = rep.data.result.listOrg;
        }
    }
}
const session=new SessionStore();
export default session;